<template>
  <div class="moow-master-container play-background">
    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <b-container class="moow-resp-container dashboard-container">
      <p class="moow-header">Finish up tenat details for a deal.</p>
      <md-steppers :md-active-step.sync="active" md-linear class="play-steppers">
        <md-step id="tenant" md-label="Lead Tenant" :md-done.sync="tenantDone">
          <p class="moow-header">Tenant Details</p>
          <private-person-search ref="personSearchRef"></private-person-search>

          <b-row v-if="tenantIsCompany">
            <b-col>
              <p class="moow-header">Company Details</p>
              <juridical-person-search ref="jurPersonSearchRef"></juridical-person-search>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <md-checkbox v-model="tenantIsCompany" class="md-primary">Tenant is a company</md-checkbox>
            </b-col>
          </b-row>

          <div class="md-layout">
            <div class="md-layout-item"></div>
            <div class="md-layout-item" style="text-align:right">
              <moow-button
                :type="['light']"
                btnText="Next"
                @mClick="attemptStep('tenant', 'details')"
              />
            </div>
          </div>
        </md-step>

        <md-step
          id="details"
          md-label="Review"
          :md-error="detailsStepError"
          :md-done.sync="detailsDone"
        >
          <div class="md-layout">
            <div class="md-layout-item">
              <md-card class="island-card half">
                <md-card-header>
                  <div class="md-title">Guests</div>
                </md-card-header>
                <md-card-content>
                  <div class="md-layout">
                    <div class="md-layout-item md-size-50 md-small-size-100">
                      <md-field :class="{ 'md-invalid': nrOfGuestsComingErr }">
                        <label>Nr Of Guests</label>
                        <md-input v-model="guests.length" type="number" readonly></md-input>
                        <span class="md-error">{{nrOfGuestsComingErr}}</span>
                      </md-field>
                    </div>
                  </div>
                  <guests-block v-model="guests"></guests-block>
                </md-card-content>
              </md-card>
            </div>
          </div>
          <div class="md-layout mb-2">
            <div class="md-layout-item">
              <rental-terms ref="rentalTermsFormRef" :readonly="false" />
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item"></div>
            <div class="md-layout-item" style="text-align:right">
              <moow-button :type="['light']" btnText="Finish" @mClick="finish" />
            </div>
          </div>
        </md-step>
      </md-steppers>
    </b-container>

    <error-snackbar
      :message="errorSnackbarMessage"
      :duration="Number(4000)"
      :showSnackbar="showErrorSnackbar"
      position="center"
      :isInfinity="false"
    ></error-snackbar>

    <md-dialog
      :md-active.sync="importLoading"
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
    >
      <div class="loader-dialog-content">
        <div class="inner-div-central">
          <md-icon
            v-if="importDone_beforeDelay_result=='success'"
            class="md-size-5x"
            style="color:white"
          >check</md-icon>
          <md-icon
            v-else-if="importDone_beforeDelay_result=='fail'"
            class="md-size-5x"
            style="color:white"
          >notification_important</md-icon>
          <div
            v-else
            class="loader-rolling-local_white"
            style="margin:0 auto; width:100px;height:100px;"
          />
          <p>{{importLoadingText}}</p>
        </div>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import PrivatePersonSearch from "@/components/person/privatePersonSearch.vue";
import JuridicalPersonSearch from "@/components/person/juridicalPersonSearch.vue";
import RentalTerms from "@/components/bookings/deals/rentalTerms.vue";
import Snackbar from "@/components/snackbar.vue";
import TenantDetailsForm from "@/components/bookings/tenantForm.vue";
import { filterListingsBasedOn } from "@/searchFunctions.js";
import contractTemplateValues from "@/config/contract_template_values.json";
import {
  idCodeTo_DDMonthYYYY,
  idCodeToDate,
} from "@/utils/other/services/identityService.js";
import { formatTimeToMonthDDYY, formatTimeToDDMMYY } from "@/timeFunctions";
import { decodeStringToObject } from "@/platform/utils/encoding/encoderService.js";
import GuestsBlock from "./GuestsBlock.vue";
import {
  captureMessage,
  captureException
} from "@/utils/reporting/reportingService.js";
export default {
  props: {},
  components: {
    "error-snackbar": Snackbar,
    "private-person-search": PrivatePersonSearch,
    "juridical-person-search": JuridicalPersonSearch,
    "rental-terms": RentalTerms,
    GuestsBlock,
  },
  data() {
    return {
      tenantIsCompany: false,
      active: "tenant",
      tenantDone: false,
      detailsDone: false,
      detailsStepError: null,
      nrOfGuestsLocal: 1,
      nrOfGuestsComingErr: "",
      additionalFees: [],
      loaderValue: null,
      importLoading: false,
      importLoadingText: "Creating",
      activeStep: "selectListing",
      importDone_beforeDelay_result: false,
      selectedContractType: "tenancyAgreement",
      loading: false,
      showErrorSnackbar: false,
      errorSnackbarMessage: "",
      leadTenant: {},
      tenantCompany: {},
      lessorEmail: "",
      lessorAddress: "",
      guests: [],
    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  watch: {
    nrOfGuestsLocal: function (val) {
      if (val < 1) this.nrOfGuestsLocal = 1;
    },
    leadTenant: {
      deep: true,
      handler: function (tenant) {
        const guest = {
          name: tenant.givenName + " " + tenant.surname,
          email: tenant.email,
          phone: tenant.phone,
          seq: 0,
        };
        if (!this.guests.length) {
          this.guests.push(guest);
        } else {
          this.guests[0] = guest;
        }
      },
    },
  },
  computed: {
    propertyAddress() {
      if (
        !this.$store.getters.property ||
        !this.$store.getters.property.location
      )
        return "";
      else return this.$store.getters.property.location.address.formattedAD;
    },
  },
  mounted() {
    if (this.$route.query.encontent) this.mapUsingEncodedParams();
    window.scrollTo(0, 0);
  },
  created() {},
  methods: {
    mapUsingEncodedParams() {
      var paramsContainer;
      this.$route.query.encontent
        ? (paramsContainer = decodeStringToObject(this.$route.query.encontent))
        : void 0;
      if (paramsContainer && paramsContainer.healthy) {
        console.log(
          "paramsContainer.application:",
          paramsContainer.application
        );

        this.$store.commit("DA_SET", paramsContainer.application);
      } else {
        // TODO: Warn user about the invalid content  and redirect back, contact support!
      }
    },
    attemptStep(id, index) {
      console.log('attemptStep');
      
      if (id == "tenant") {
        var validPrivPerson = this.$refs.personSearchRef.getValidPerson();
        if (validPrivPerson) {
          this.leadTenant = validPrivPerson;
          if (this.tenantIsCompany) {
            var validJurPerson = this.$refs.jurPersonSearchRef.getValidPerson();
            if (validJurPerson) {
              this.tenantCompany = validJurPerson;
              this.takeStep(id, index);
            }
          } else {
            this.takeStep(id, index);
          }
        }
      } else this.takeStep(id, index);
    },
    takeStep(id, index) {
      this.detailsDone = true;
      this[id] = true;
      if (index) this.active = index;
    },
    finish() {
      if (this.$refs.rentalTermsFormRef.validateForm()) {
        this.importLoading = true;
        this.$store
          .dispatch("createNewDeal", {
            property: this.$store.getters.property,
            lesseeDet: this.makeLesseeDetails(),
            lessorDet: this.$store.getters.lessor,
            contractDetails: this.makeContractDetails(),
            lessorAccountId: this.$store.getters.lessorAccountId,
          })
          .then((response) => {
            this.initiateLoaderEnd("success", "Deal created", 1500, {
              action: "redirect",
              message: "",
              success: true,
            });
          })
          .catch((err) => {
            this.initiateLoaderEnd("fail", err, 2000, {
              action: "notify",
              message: "Cannot create deal",
              success: false,
            });
          });
      }
    },
    makeLesseeDetails() {
      var lesseeDet = {
        privatePerson: this.leadTenant,
        jurPerson: null,
        rep: "private",
      };
      if (this.tenantIsCompany) {
        lesseeDet.jurPerson = this.tenantCompany;
        lesseeDet.rep = "juridical";
      }
      return lesseeDet;
    },
    makeContractDetails() {
      return {
        terms: this.$store.getters.terms,
        contract: this.$store.getters.contract.contract,
        nrOfGuests: this.guests.length,
        guests: this.getGuests(),
        houseRules: this.$store.getters.houseRules,
      };
    },
    getGuests() {
      return this.guests.filter((guest) => !!guest.name);
    },
    redirectTo(name, params) {
      this.$router.push({
        name: name,
        params: params,
      });
    },
    notifyError(title, msg) {
      this.$notify({
        title: title,
        message: msg,
      });
    },
    showSnackbar(msg) {
      this.showErrorSnackbar = true;
      this.errorSnackbarMessage = msg;
    },
    hideSnackbar() {
      this.showErrorSnackbar = false;
      this.errorSnackbarMessage = "";
    },
    initiateLoaderEnd(success, msg, onScreenTime, afterActionPayload) {
      if (afterActionPayload.success) this.importLoadingText = msg;
      else {
        this.importLoadingText = "Unsuccessful Operation";
        captureException(msg);
      } 

      this.importDone_beforeDelay_result = success;
      var millisecondsToWait = onScreenTime;
      var self = this;
      setTimeout(function () {
        // Whatever you want to do after the wait
        self.importLoading = false;

        if ((afterActionPayload.action = "redirect")) {
          self.redirectTo("manage", {
            listing: self.$store.getters.property,
          });
        } else if ((afterActionPayload.action = "notify")) self.notifyError(afterActionPayload.message);
      }, millisecondsToWait);
    },
  },
};
</script>
<style scoped>
@import "../../../assets/styles/booking.css";
@import "../../../assets/styles/dashboard.css";
@import "../../../assets/styles/global.css";

.selectedListing {
  color: white;
  background-color: #4589fa;
}
</style>



// WEBPACK FOOTER //
// src/components/bookings/deals/DealApplicationLessee.vue